export default "__VITE_ASSET__560178c0__"